import React from "react";
import EngagementTable from "./EngagementTable";
import ReportProgramsPage from "../../components/ReportProgramsPage";

const EngagementIndex = () => (
  <ReportProgramsPage
    TableComponent={EngagementTable}
    loadingMessage="Loading referral participant report..."
  />
);

export default EngagementIndex;
